import { render, staticRenderFns } from "./ProfitDetail.vue?vue&type=template&id=18ef82ba&scoped=true&"
import script from "./ProfitDetail.vue?vue&type=script&lang=js&"
export * from "./ProfitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef82ba",
  null
  
)

export default component.exports